module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-0 kios-item"
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('h4', {
    staticClass: "pt-2 ml-2"
  }, [_c('span', {
    staticStyle: {
      "color": "#065694"
    }
  }, [_vm._v("TRA CỨU THỦ TỤC HÀNH CHÍNH ")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "box": "",
      "items": _vm.govAgencyList,
      "label": "Cơ quan",
      "item-text": "administrationName",
      "item-value": "administrationCode",
      "hide-selected": true,
      "color": "primary",
      "clearable": "",
      "height": "48"
    },
    on: {
      "change": _vm.changeAdministration
    },
    model: {
      value: (_vm.govAgencySelected),
      callback: function($$v) {
        _vm.govAgencySelected = $$v
      },
      expression: "govAgencySelected"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "box": "",
      "items": _vm.listLinhVuc,
      "label": "Lĩnh vực",
      "item-text": "domainName",
      "item-value": "domainCode",
      "hide-selected": true,
      "color": "primary",
      "clearable": "",
      "height": "48"
    },
    on: {
      "change": _vm.changeDomain
    },
    model: {
      value: (_vm.linhVucSelected),
      callback: function($$v) {
        _vm.linhVucSelected = $$v
      },
      expression: "linhVucSelected"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "input-custom"
  }, [_c('input', {
    attrs: {
      "id": "serviceNameKey",
      "type": "text",
      "required": "required"
    },
    on: {
      "focus": _vm.show,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterServiceinfos('keyword')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "serviceNameKey"
    }
  }, [_vm._v("Tên thủ tục hành chính")]), _vm._v(" "), _c('v-icon', {
    staticClass: "icon-prepend text-bold",
    attrs: {
      "size": "18"
    },
    on: {
      "click": function($event) {
        return _vm.filterServiceinfos('keyword')
      }
    }
  }, [_vm._v("search")])], 1)])], 1), _vm._v(" "), (_vm.loading) ? _c('content-placeholders', {
    staticClass: "mt-3"
  }, [_c('content-placeholders-text', {
    attrs: {
      "lines": 10
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.activeDetailService && !_vm.showListThuTuc && _vm.govAgencyList && !_vm.govAgencySelected && _vm.govAgencyList.length > 0) ? _c('div', {
    staticClass: "mt-4 ml-1",
    class: _vm.visible ? 'overlayActive' : ''
  }, [_c('v-layout', {
    staticClass: "wrap"
  }, _vm._l((_vm.govAgencyList), function(item, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "pr-3",
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-select",
      staticStyle: {
        "width": "100%",
        "background-color": "#b3d4fc5c!important"
      },
      attrs: {
        "outline": "",
        "flat": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.filterAdministration(item)
        }
      }
    }, [_vm._v(_vm._s(item.administrationName))])], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.activeDetailService && !_vm.showListThuTuc && _vm.listLinhVuc && _vm.govAgencySelected && !_vm.linhVucSelected && _vm.listLinhVuc.length > 0) ? _c('div', {
    staticClass: "mt-4 pb-2 mx-2",
    class: _vm.visible ? 'overlayActive' : ''
  }, [_c('div', {
    staticClass: "wrap-scroll wrap-scroll-domain list-domain"
  }, [_c('v-list', {
    staticClass: "py-0"
  }, [_vm._l((_vm.listLinhVuc), function(item, index) {
    return [_c('v-list-tile', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.filterDomain(item)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.domainName)
      }
    })], 1)], 1)]
  })], 2)], 1), _vm._v(" "), (_vm.totalPaggingLinhVuc > 10) ? _c('div', {
    staticClass: "text-xs-center layout wrap mt-2",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "flex pagging-table px-2"
  }, [_c('tiny-pagination', {
    attrs: {
      "total": _vm.totalPaggingLinhVuc,
      "page": _vm.pageListLinhVuc,
      "custom-class": "custom-tiny-class"
    },
    on: {
      "tiny:change-page": _vm.paggingData
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.activeDetailService && _vm.showListThuTuc) ? _c('div', {
    staticClass: "mt-4",
    class: _vm.visible ? 'overlayActive' : ''
  }, [_c('div', {
    staticClass: "wrap-scroll wrap-scroll-tableservice"
  }, [_c('v-data-table', {
    staticClass: "table-bordered table-thu-tuc ml-2",
    attrs: {
      "headers": _vm.headersTable,
      "items": _vm.listThuTuc,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: {
            'active': props.index % 2 == 1
          },
          on: {
            "click": function($event) {
              return _vm.viewDetail(props.item)
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-center"
        }, [(_vm.loading) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.pageListThuTuc * 10 - 10 + props.index + 1))]), _c('br')])], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [(_vm.loading) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_vm._v(_vm._s(props.item.serviceName))])])], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [(_vm.loading) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_c('span', [_vm._v(_vm._s(props.item.domainName))])])])], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [(_vm.loading) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_c('v-chip', {
          staticClass: "mx-0 my-0",
          staticStyle: {
            "height": "25px"
          },
          attrs: {
            "label": "",
            "color": _vm.getColor(props.item.maxLevel),
            "text-color": "white"
          }
        }, [_vm._v("\n                      Mức độ " + _vm._s(props.item.maxLevel) + "\n                    ")])], 1)])], 1)])]
      }
    }], null, false, 1336454382)
  }, [_vm._v(" "), _c('template', {
    slot: "no-data"
  }, [_c('div', {
    staticClass: "text-xs-center mt-2"
  }, [_vm._v("\n              Không có thủ tục nào được tìm thấy\n            ")])])], 2)], 1), _vm._v(" "), (_vm.totalPaggingThuTuc > 10) ? _c('div', {
    staticClass: "text-xs-center layout wrap mt-2",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "flex pagging-table px-2"
  }, [_c('tiny-pagination', {
    attrs: {
      "total": _vm.totalPaggingThuTuc,
      "page": _vm.pageListThuTuc,
      "custom-class": "custom-tiny-class"
    },
    on: {
      "tiny:change-page": _vm.paggingData
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.activeDetailService) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('chi-tiet-thu-tuc', {
    attrs: {
      "index": _vm.serviceId
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.visible && !_vm.isMobile) ? _c('div', {
    staticClass: "virtual-keyboard"
  }, [_c('v-btn', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "0"
    },
    attrs: {
      "small": "",
      "fab": "",
      "color": "#383533"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#fff"
    }
  }, [_vm._v("clear")])], 1), _vm._v(" "), (_vm.visible) ? _c('vue-touch-keyboard', {
    attrs: {
      "layout": _vm.layout,
      "cancel": _vm.hide,
      "accept": _vm.accept,
      "input": _vm.input,
      "next": _vm.next,
      "options": _vm.options
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "fab": "",
      "color": "primary"
    },
    on: {
      "click": _vm.changeScreen
    }
  }, [(!_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "size": "20",
      "dark": ""
    }
  }, [_vm._v("fullscreen")]) : _vm._e(), _vm._v(" "), (_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "size": "20",
      "dark": ""
    }
  }, [_vm._v("fullscreen_exit")]) : _vm._e()], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-97b0229c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97b0229c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TraCuuThuTuc.vue
// module id = 536
// module chunks = 1